// inbox/serverErrorCodes.js — 5A-final2 (البند 2)
// قاموس عربي واحد لكل رموز أخطاء الخادم في مسارات الصندوق. الخادم يعيد
// رمزاً قصيراً (مثل "resolution_required") لا جملة إنجليزية خام؛ هذا
// الملف يترجمه. رسالة عربية جاهزة من الخادم (تحتوي حروفاً عربية) تُعرَض
// كما هي. أي رمز غير معروف يظهر «تعذّر الحفظ — رمز: X» — لا يظهر نص
// إنجليزي خام مطلقاً لموظفة الصندوق.
const CODE_LABELS = {
  type_required: "اختر نوع التفاعل قبل الإغلاق.",
  product_required: "اختر منتجاً، أو فعّل «لا يخص منتجاً».",
  resolution_required: "هذا النوع يتطلب حلاً — اختر حلاً قبل الإغلاق.",
  cancel_reason_required: "أدخل سبب الإلغاء.",
  interaction_not_open: "هذا التفاعل غير مفتوح حالياً.",
  unknown_type: "نوع غير معروف.",
  unknown_text_key: "مفتاح نص غير معروف.",
  customer_phone_required: "رقم جوال العميل مطلوب.",
  invalid_channel: "قناة غير صالحة.",
  invalid_direction: "اتجاه غير صالح.",
};

function looksArabic(s) {
  return /[\u0600-\u06FF]/.test(s);
}

export function translateServerError(detail, fallback = "تعذّر الحفظ") {
  if (!detail || typeof detail !== "string") return fallback;
  const code = detail.trim();
  if (CODE_LABELS[code]) return CODE_LABELS[code];
  if (looksArabic(code)) return code; // رسالة عربية جاهزة من الخادم أصلاً
  return `تعذّر الحفظ — رمز: ${code}`;
}
